<template>
  <div>
    <div class="signs">
      <img style="width:100%;" src="@/assets/images/customerCase/banner.png" alt />
      <img class="signs_title" src="@/assets/images/customerCase/banner_text.png" alt="">
    </div>
    <div class="caseContainer"> 
      <div class="title_box">
        <div :class='{active: select === 0}' @click="changeTitle(0)">
             <img style="margin-left:50px;" src="@/assets/images/customerCase/title_tea.png" alt />
             <div class="title_text">茶饮连锁</div>
        </div>
        <div :class='{active: select === 1}' @click="changeTitle(1)">
             <img class="title_img" src="@/assets/images/customerCase/title_food.png" alt />
             <div class="title_text">餐饮连锁</div>
        </div>
        <div :class='{active: select === 2}' @click="changeTitle(2)">
             <img class="title_img" src="@/assets/images/customerCase/title_clothes.png" alt />
             <div class="title_text">服装鞋帽</div>
        </div>
         <div :class='{active: select === 3}' @click="changeTitle(3)">
             <img class="title_img" src="@/assets/images/customerCase/title_shop.png" alt />
             <div class="title_text">超市便利</div>
        </div>
         <div :class='{active: select === 4}' @click="changeTitle(4)">
             <img class="title_img" src="@/assets/images/customerCase/title_create.png" alt />
             <div class="title_text">智能制造</div>
        </div>
        <div :class='{active: select === 5}' @click="changeTitle(5)">
             <img class="title_img" src="@/assets/images/customerCase/title_movie.png" alt />
             <div class="title_text">影院影城</div>
        </div>
      </div>
      <div class="container_box">
        <div class="container_tab" v-show="select === 0">
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/1.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon1.png" alt="">
                    <div class="icon_title">蜜雪冰城</div>
                    <div class="icon_text">
                        总部管控25000＋门店，通过云幕，集中管理全国门店屏幕，整合音频播放、叫号系统助力营销；通过云千目，智能巡店辅助督导工作，高效、准确获得巡店数据，支撑经营决策
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/2.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon2.png" alt="">
                    <div class="icon_title">幸运咖</div>
                    <div class="icon_text">
                        全国门店已突破2300家，伴随着品牌快速发展的步伐，云幕为幸运咖定制连锁门店管理方案，激发营销活力，升级宣传工具，降低运营成本
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/3.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon3.png" alt="">
                    <div class="icon_title">茶颜悦色</div>
                    <div class="icon_text">
                        进一城，深耕一城，茶颜悦色全国直营门店已突破600家，严格把控门店及产品运营，坚定地选择云幕作为合作伙伴，优化门店智慧显示，推动标准化管理再升级
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/4.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon4.png" alt="">
                    <div class="icon_title">CoCo都可</div>
                    <div class="icon_text">
                        创立于中国台湾的CoCo都可，全球门店已超4500家，依托云幕，分级管理，高效控制门店屏幕，满足多种展现形式，构建连锁门店数字化管理新模式
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/5.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon5.png" alt="">
                    <div class="icon_title">Seesaw咖啡</div>
                    <div class="icon_text">
                        精品咖啡品牌Seesaw(西舍)获得喜茶首次投资，与此同时，携手云幕在门店数字化建设领域深度合作以用户体验为先，最大化利用门店设备，以更多交互方式为门店引流
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/6.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon6.png" alt="">
                    <div class="icon_title">雅克雅思</div>
                    <div class="icon_text">
                        目前在全国开设200多家门店，以持续创新的理念驱动门店数字化转型与发展，通过对比，选择部署云幕管理系统，高效管理门店屏幕，开启动态视觉营销新时代
                    </div>
                </div>
            </div>
        </div>
         <div class="container_tab" v-show="select === 1">
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/7.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon7.png" alt="">
                    <div class="icon_title">泸溪河</div>
                    <div class="icon_text">
                        国民糕点品牌-泸溪河，近400家直营门店全面部署云幕管理系统，统一品牌形象宣传，通过数字化辅助业务运营，以实现数据驱动营销
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/8.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon8.png" alt="">
                    <div class="icon_title">鱼你在一起</div>
                    <div class="icon_text">
                       中国餐饮品牌百强-鱼你在一起，与云幕深度合作，伴随着每年300家以上门店的数量高速增长，同步进行适配企业发展、深度管理的数字化建设，打造千店千面
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/9.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon9.png" alt="">
                    <div class="icon_title">小厨娘淮扬菜</div>
                    <div class="icon_text">
                        大型餐饮连锁品牌-小厨娘，以屏幕为触点，搭建门店视觉体系及打磨用餐体验细节，统一智能电视及LED大屏的管理，提升效率，助力营销
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/10.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon10.png" alt="">
                    <div class="icon_title">巴庄火锅</div>
                    <div class="icon_text">
                        知名餐饮连锁-巴庄火锅，95%以上门店位居当地餐饮业头牌，在市场需求和公司战略发展的双轮驱动下，巴庄携手云幕，按下数字化升级快进键
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/11.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon11.png" alt="">
                    <div class="icon_title">标头炸串</div>
                    <div class="icon_text">
                        国产炸物，新创潮牌-标头炸串，通过云幕统一管理全国门店屏幕，并根据需求开发更多扩展性功能。通过云千目，实现高效巡店，提升标准化管理
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/12.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon12.png" alt="">
                    <div class="icon_title">蛙来哒</div>
                    <div class="icon_text">
                        牛蛙美食品类开创者-蛙来哒，覆盖全国90多个城市。通过云幕，玩转屏幕矩阵引流靓店，同步播放打造氛围感，实现门店营销效果和效率双重提升
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/19.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon19.png" alt="">
                    <div class="icon_title">龙门花甲</div>
                    <div class="icon_text">
                        创立于2014年的龙门花甲，自开放加盟以来，连锁门店数量已突破6500家，并先后获得了“中国餐饮行业十大著名品牌”、“中国特色餐饮名店”等殊荣
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/20.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon20.png" alt="">
                    <div class="icon_title">熊家无二</div>
                    <div class="icon_text">
                        全球门店已突破1000家，覆盖省份30+，遍布170+海内外城市。选择部署云幕管理系统及云幕定制商显，高效管理门店屏幕，开启数字化驱动运营新时代
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/21.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon21.png" alt="">
                    <div class="icon_title">KUMO KUMO</div>
                    <div class="icon_text">
                        KUMO KUMO在产品和制作工艺上打造独特记忆点，充满仪式感的消费体验让品牌迅速出圈。依托云幕构建连锁门店数字化管理新模式，创造新的智慧营销
                    </div>
                </div>
            </div>
        </div>
         <div class="container_tab" v-show="select === 2">
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/13.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon13.png" alt="">
                    <div class="icon_title">CK Jeans</div>
                    <div class="icon_text">
                        知名时尚品牌CK旗下牛仔品牌，引领新零售发展携手云幕升级门店形象。LED大屏实现多种播放方式，展示品牌活动信息，引流靓店
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/14.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon14.png" alt="">
                    <div class="icon_title">快鱼</div>
                    <div class="icon_text">
                       中国领先的平价时尚休闲服品牌，结合门店不同区域配置屏幕，通过云幕投放新品上架、爆款推荐、特价优惠等，配合营销节奏，提升销量转化
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/15.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon15.png" alt="">
                    <div class="icon_title">堡狮龙</div>
                    <div class="icon_text">
                        来自中国香港的潮流服装品牌，针对引流需求，通过云幕实现LED屏的拼接联屏播放，支持按营销节点、节日、时段设置自动播放，提高运营效率
                    </div>
                </div>
            </div>
        </div>
        <div class="container_tab" v-show="select === 3">
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/16.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon16.png" alt="">
                    <div class="icon_title">芙鹿家</div>
                    <div class="icon_text">
                        国内专业的轻连锁便利店品牌，云幕针对便利店不同区域播放对应节目，管理背景音乐等音频播放，根据不同地区不同时段、天气等实现智能化推送
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/22.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon22.png" alt="">
                    <div class="icon_title">零食有鸣</div>
                    <div class="icon_text">
                        量贩零食连锁品牌零食有鸣已完成数千万元战略轮融资，目前全国开设门店超过1000家，在与云幕的深度合作中，加速门店管理的数字化升级
                    </div>
                </div>
            </div>
        </div>
        <div class="container_tab" v-show="select === 4">
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/17.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon17.png" alt="">
                    <div class="icon_title">杜肯集团</div>
                    <div class="icon_text">
                        全球HVAC系统领域龙头企业-杜肯DURKEE坚定地选择云幕作为合作伙伴，在企业智慧展厅屏幕管理及数字化车间智能电子看板等方面合作提升
                    </div>
                </div>
            </div>
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/23.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon23.png" alt="">
                    <div class="icon_title">新康众</div>
                    <div class="icon_text">
                        在康众汽配连锁的基础上，融入阿里巴巴集团汽车后市场业务及相关资源而成立，与云幕合作，提升门店品牌形象及标准化管理，优化服务水准，加强核心竞争力
                    </div>
                </div>
            </div>
        </div>
        <div class="container_tab" v-show="select === 5">
            <div class="container_item">
                <img class="container_img" src="@/assets/images/customerCase/18.png" alt="">
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon18.png" alt="">
                    <div class="icon_title">幸福蓝海国际影城</div>
                    <div class="icon_text">
                        从候影区到内场通道，我们根据影院需求提供一整套数字化展示方案。通过拼接大屏和横幅效果的联屏，抓住视觉营销,提升广告宣传效果
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      select: 0
    };
  },
  methods:{
    changeTitle(i) {
      this.select = i;
    },
  }
};
</script>

<style scoped>
.caseContainer {
  width: 1200px;
  margin: 0 auto;
}

.signs {
  width: 100%;
  margin-bottom: 60px;
  position: relative;
}

.signs .signs_title {
    position: absolute;
    top:55%;
    left:37%;
    transform: translate(-50% ,-50%);
}

.title_box {
    display: flex;
    justify-content: space-around;
    padding-top:60px;
}

.title_text {
    margin-top:30px;
    font-size:22px;
    font-weight: 600;
    color: #303133;
    cursor: pointer;
    width: 156px;
    text-align: center;
}

.active {
  border-bottom: 4px solid #f39800;
}

.title_img {
    margin-left:40px;
}

.active .title_text {
  color: #f39800;
  margin-bottom:10px;
}

.container_box {
    padding-top:30px;
}

.container_tab {
    display: flex;
    flex-wrap: wrap;
    margin-bottom:160px;
}

.container_item {
    position: relative;
    height: 388px;
    width: 400px;
    margin-bottom:32px;
}

.container_img {
    position: absolute;
    top:0;
    left:0;
}

.container_bg {
    position: absolute;
    bottom:0;
    left:-8px;
    width: 382px;
    height: 230px;
    background: url('~@/assets/images/customerCase/container_bg.png');
    padding:60px 32px 0 38px;
}

.icon_img {
    position: absolute;
    top:11px;
    left:37px;
}

.icon_title {
    color: #3B436B;
    font-size: 22px;
    margin-bottom: 30px;
}

.icon_text {
    color: #75798C;
    font-size:14px;
}

</style>



// WEBPACK FOOTER //
// src/components/CustomerCase.vue